import {z} from 'zod';

type TranslateFn = (key: string) => string;

export const getEditPresetSchema = (t: TranslateFn) =>
  z.object({
    title: z.string().trim().min(1, t('general.notifications.errorFieldRequired')),
    // nullish() = optional + nullable: on the create flow the field is untouched
    // and its value is `undefined`, which `.nullable()` alone would reject —
    // making the optional description behave as required.
    description: z.string().nullish(),
  });
